angular.module('CarsSaraBo').factory('FleetService', ['$resource', function($resource) {
  
  return $resource('../rest/company/:companyOid/fleet/:oid/:brand/:model/:country',
    {
      companyOid : '@companyOid',
      oid : '@oid',
      brand:'@brand',
      model:'@model',
      contry:'@country'
    },
    {
      post : {method:'POST'},
      update : { method: 'PUT'},
      remove : { method: 'DELETE'},
      get: {method:'GET', isArray:true},
      getOne: {method:'GET'}
    }
  );
}]);


//////////////////
// WEBPACK FOOTER
// ./public/app/models/fleet_service.js
// module id = 845
// module chunks = 3